import { useContext } from 'react';
import { EventData } from './useSearchBarEvents';
import SearchBarContext from '../SearchBarContext';
import { encodeAndStringify } from '../utils';

export default function useGetSuggestionHref() {
  const { refSource } = useContext(SearchBarContext);

  return (href: string, eventData: Partial<EventData>) => {
    const url = new URL(`https://www.example.com${href}`);

    url.searchParams.set('refSource', refSource);
    if (Object.keys(eventData).length)
      url.searchParams.set('searchEvent', encodeAndStringify(eventData));

    return url.pathname + url.search;
  };
}
